import { getIsMakesApiPending } from '../../../selectors/ugMotorInsurance/quote';
import { apiTransitionCarMakes, setCarMakesValid, setCarMakesValue } from '../../../actions/ugMotorInsurance/quote';
import { getAccessToken } from '../../../selectors/ugMotorInsurance/payments';
import axios from 'axios';

export const getUgCarMakesService = (store, next, action) => {
    (async () => {
        if (!getIsMakesApiPending(store.getState())) {
            store.dispatch(apiTransitionCarMakes.pending());
            try {
                const resp = await getMakes(store.getState());

                store.dispatch(setCarMakesValue(resp.data.carMakes));
                store.dispatch(apiTransitionCarMakes.success());
            } catch (e) {
                console.error(e);
                store.dispatch(apiTransitionCarMakes.failure());
                store.dispatch(setCarMakesValid(e));
            }
        }
    })();
    return next(action);
};

const getMakes = async (state) => {
    const loginData = getAccessToken(state);

    try {
        const url = '/om-api/ug-motor-insurance/car-makes/v2';
        return await axios.get(url, {
            headers: {
                'Content-Type': 'application/json',
                accessToken: loginData.accessToken,
            },
        });
    } catch (e) {
        console.error(e);
        throw e;
    }
};
